import React, { PropTypes } from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import DataSet from './DataSet';

export default class Root extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    routes: PropTypes.element.isRequired,
    store: PropTypes.object.isRequired,
    data: PropTypes.object,
  };

  render() {
    const { history, routes, store, data } = this.props;

    return (
      <Provider store={store}>
        <div style={{ height: '100%' }}>
          <DataSet data={data}>
            <Router history={history} children={routes} />
          </DataSet>
        </div>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/containers/Root.js